<template>
  <div>
    <h6 class="text-uppercase text-muted font-weight-bold mb-3">
      <i class="fas fa-check-circle mr-1"></i> Active Subscriptions
    </h6>

    <div v-if="loading" class="text-center py-3 text-muted">
      <i class="fas fa-spinner fa-spin"></i>
    </div>

    <p v-else-if="subscriptions.length === 0" class="text-muted small mb-0">
      No active subscriptions found.
    </p>

    <div v-else class="table-responsive">
      <table class="table table-sm table-borderless mb-0">
        <thead class="thead-light">
          <tr>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Plan</th>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Amount</th>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Status</th>
            <th class="text-uppercase text-muted small font-weight-bold border-0">Next Billing</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sub, i) in subscriptions" :key="i">
            <td class="align-middle small font-weight-bold">{{ sub.product_name }}</td>
            <td class="text-nowrap align-middle small">
              {{ sub.amount }}<span v-if="sub.interval" class="text-muted"> / {{ sub.interval }}</span>
            </td>
            <td class="align-middle">
              <span
                class="badge"
                :class="{
                  'badge-success': sub.status === 'active',
                  'badge-info':    sub.status === 'trialing',
                  'badge-warning': sub.status === 'past_due',
                  'badge-secondary': ['canceled', 'unpaid', 'incomplete_expired'].includes(sub.status),
                }"
              >{{ sub.status }}</span>
              <span v-if="sub.cancel_at_period_end" class="badge badge-warning ml-1">Cancels at period end</span>
            </td>
            <td class="text-nowrap align-middle small">{{ sub.current_period_end || '—' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  name: 'ActiveSubscriptions',
  data() {
    return {
      subscriptions: [],
      loading: false,
    };
  },
  methods: {
    fetch() {
      this.loading = true;
      axios({ url: 'payments/activeSubscriptionsGet' })
        .then(res => {
          if (res.data.status === 1) {
            this.subscriptions = res.data.result.subscriptions;
          }
        })
        .catch(() => {})
        .finally(() => { this.loading = false; });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
